module.exports = __webpack_public_path__ + "static/media/CosmoDK.0ee054bd.png";